module.exports = __webpack_public_path__ + "static/media/3DMaker_t.34b5d65d.svg";